export default "__VITE_ASSET__Bo_m_qpf__"